import React from 'react'
import './QueryAnalysis.css'

const ErrorText = ({ message = '' }) => {
  return <div className="error_message">{message}</div>
}

export default ErrorText
